let fetch: typeof window.fetch;

if (typeof window !== 'undefined') {
  fetch = window.fetch;
} else {
  fetch = require('node-fetch').default; // eslint-disable-line @typescript-eslint/no-require-imports
}

export default fetch;
